module.exports = __webpack_public_path__ + "static/media/ie.116f300a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ie.svg
// module id = 936
// module chunks = 0